module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex fd-column"
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.lista,
      "label": "Direccion",
      "placeholder": "Realiza la busqueda por la desripción",
      "dense": "dense",
      "item-value": "id",
      "item-text": "direccion",
      "return-object": "return-object",
      "hide-details": "hide-details"
    },
    on: {
      "change": _vm.seleccionarClick
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(data) {
        return [_c('v-list', {
          staticClass: "my-0 py-0",
          attrs: {
            "dense": "dense"
          }
        }, [_c('v-list-item-content', [_c('v-list-item-title', {
          staticClass: "font-size-12",
          domProps: {
            "innerHTML": _vm._s(data.item.id)
          }
        }), _c('v-list-item-subtitle', {
          staticClass: "font-size-11",
          domProps: {
            "innerHTML": _vm._s(data.item.direccion)
          }
        })], 1)], 1)]
      }
    }]),
    model: {
      value: (_vm.idDireccion),
      callback: function($$v) {
        _vm.idDireccion = $$v
      },
      expression: "idDireccion"
    }
  }), (_vm.idDireccion) ? _c('small', {
    staticClass: "mt-1 text-muted"
  }, [_vm._v(_vm._s(_vm.idDireccion))]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5200a83c","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/c_direcciones_cliente_seleccionar.vue
// module id = 499
// module chunks = 1